import React, { useEffect, useState } from "react";
import ReactDOM from "react-dom";
import XbuttonGrowth from "graphics/icons/XbuttonGrowth.js";
import XbuttonBusiness from "graphics/icons/XbuttonBusiness.js";
import { useDispatch } from "react-redux";
import { setModalActive } from "slices/generalSlice";

const fadeTime = 100; // (ms) to be coordinated with "modal-backdrop" class transition time

const Modal = (props) => {
  const dispatch = useDispatch();
  const [show, setShow] = useState(false);
  const onDismiss = () => {
    if (!props.persist) setShow(false);
    setTimeout(props.onDismiss, fadeTime); //timeout duration to be kept same as animation duration
  };

  useEffect(() => {
    // Made this timeout to force React to render with an initial state of show=false
    setTimeout(() => {
      setShow(true);
    }, 10);
    dispatch(setModalActive(true));
    return () => dispatch(setModalActive(false));
  }, [dispatch]);
  return ReactDOM.createPortal(
    <div
      className={`modal-backdrop ${
        props.lightBackDrop ? "modal-backdrop-light" : "modal-backdrop-dark"
      } ${show ? "" : "hide"} `}
      onClick={props.noBackDropClick ? (e) => e.stopPropagation() : onDismiss}
    >
      <div
        className={`modal-box form-shadow ${
          props.containerClass ? props.containerClass : ""
        }`}
        onClick={(e) => e.stopPropagation()}
      >
        <div
          className={`my-modal-header ${
            props.growth ? "growth-text" : "business-text"
          }`}
        >
          {props.header}
          {!props.persist && (
            <div className="modal-exit" onClick={onDismiss}>
              {props.growth ? <XbuttonGrowth /> : <XbuttonBusiness />}
            </div>
          )}
        </div>

        <div>{props.content}</div>
        <div className="modal-actions">{props.actions}</div>
      </div>
    </div>,
    document.querySelector("#modal")
  );
};

export default Modal;
